/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ original_yearly_price: NonNullable<unknown>, discount_yearly_price: NonNullable<unknown> }} Relax_Paywall_Purchase_Btn_CnaInputs */

const en_relax_paywall_purchase_btn_cna = /** @type {(inputs: Relax_Paywall_Purchase_Btn_CnaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Purchase 1 Year ${i?.original_yearly_price} ${i?.discount_yearly_price}`)
};

const ar_relax_paywall_purchase_btn_cna = /** @type {(inputs: Relax_Paywall_Purchase_Btn_CnaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Purchase 1 Year ${i?.original_yearly_price} ${i?.discount_yearly_price}`)
};

const de_relax_paywall_purchase_btn_cna = /** @type {(inputs: Relax_Paywall_Purchase_Btn_CnaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Purchase 1 Year ${i?.original_yearly_price} ${i?.discount_yearly_price}`)
};

const es_relax_paywall_purchase_btn_cna = /** @type {(inputs: Relax_Paywall_Purchase_Btn_CnaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Purchase 1 Year ${i?.original_yearly_price} ${i?.discount_yearly_price}`)
};

const fr_relax_paywall_purchase_btn_cna = /** @type {(inputs: Relax_Paywall_Purchase_Btn_CnaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Purchase 1 Year ${i?.original_yearly_price} ${i?.discount_yearly_price}`)
};

const it_relax_paywall_purchase_btn_cna = /** @type {(inputs: Relax_Paywall_Purchase_Btn_CnaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Purchase 1 Year ${i?.original_yearly_price} ${i?.discount_yearly_price}`)
};

const ja_relax_paywall_purchase_btn_cna = /** @type {(inputs: Relax_Paywall_Purchase_Btn_CnaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Purchase 1 Year ${i?.original_yearly_price} ${i?.discount_yearly_price}`)
};

const ko_relax_paywall_purchase_btn_cna = /** @type {(inputs: Relax_Paywall_Purchase_Btn_CnaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Purchase 1 Year ${i?.original_yearly_price} ${i?.discount_yearly_price}`)
};

const pt_br_relax_paywall_purchase_btn_cna = /** @type {(inputs: Relax_Paywall_Purchase_Btn_CnaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Purchase 1 Year ${i?.original_yearly_price} ${i?.discount_yearly_price}`)
};

const ru_relax_paywall_purchase_btn_cna = /** @type {(inputs: Relax_Paywall_Purchase_Btn_CnaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Purchase 1 Year ${i?.original_yearly_price} ${i?.discount_yearly_price}`)
};

const th_relax_paywall_purchase_btn_cna = /** @type {(inputs: Relax_Paywall_Purchase_Btn_CnaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Purchase 1 Year ${i?.original_yearly_price} ${i?.discount_yearly_price}`)
};

const tr_relax_paywall_purchase_btn_cna = /** @type {(inputs: Relax_Paywall_Purchase_Btn_CnaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Purchase 1 Year ${i?.original_yearly_price} ${i?.discount_yearly_price}`)
};

const zh_cn_relax_paywall_purchase_btn_cna = /** @type {(inputs: Relax_Paywall_Purchase_Btn_CnaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`购买 1 年 ${i?.original_yearly_price} ${i?.discount_yearly_price}`)
};

const zh_tw_relax_paywall_purchase_btn_cna = /** @type {(inputs: Relax_Paywall_Purchase_Btn_CnaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`购买 1 年 ${i?.original_yearly_price} ${i?.discount_yearly_price}`)
};

/**
* | output |
* | --- |
* | "Purchase 1 Year {original_yearly_price} {discount_yearly_price}" |
*
* @param {Relax_Paywall_Purchase_Btn_CnaInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const relax_paywall_purchase_btn_cna = /** @type {((inputs: Relax_Paywall_Purchase_Btn_CnaInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Relax_Paywall_Purchase_Btn_CnaInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_relax_paywall_purchase_btn_cna(inputs)
	if (locale === "ar") return ar_relax_paywall_purchase_btn_cna(inputs)
	if (locale === "de") return de_relax_paywall_purchase_btn_cna(inputs)
	if (locale === "es") return es_relax_paywall_purchase_btn_cna(inputs)
	if (locale === "fr") return fr_relax_paywall_purchase_btn_cna(inputs)
	if (locale === "it") return it_relax_paywall_purchase_btn_cna(inputs)
	if (locale === "ja") return ja_relax_paywall_purchase_btn_cna(inputs)
	if (locale === "ko") return ko_relax_paywall_purchase_btn_cna(inputs)
	if (locale === "pt_br") return pt_br_relax_paywall_purchase_btn_cna(inputs)
	if (locale === "ru") return ru_relax_paywall_purchase_btn_cna(inputs)
	if (locale === "th") return th_relax_paywall_purchase_btn_cna(inputs)
	if (locale === "tr") return tr_relax_paywall_purchase_btn_cna(inputs)
	if (locale === "zh_cn") return zh_cn_relax_paywall_purchase_btn_cna(inputs)
	return zh_tw_relax_paywall_purchase_btn_cna(inputs)
});